var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25003 3.11114C6.52618 2.92705 6.91792 2.9768 7.12503 3.22225L10.875 7.66667C11.0417 7.8642 11.0417 8.1358 10.875 8.33333L7.12503 12.7777C6.91792 13.0232 6.52618 13.073 6.25003 12.8889C5.97389 12.7048 5.91793 12.3565 6.12504 12.1111L9.59376 8L6.12504 3.88892C5.91793 3.64346 5.97389 3.29524 6.25003 3.11114Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightIcon);
export default __webpack_public_path__ + "static/media/chevron-right-icon.4cd0dde609194b89c627208de232c22a.svg";
export { ForwardRef as ReactComponent };